namespace h5_vm {

   import GosBasePageModel = h5_vm.GosBasePageModel;

   export class GosRegistrationInformationPageModel extends GosBasePageModel {
      ownerName: string;
      organizationName: string;
   }
}
